import React, { useRef, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const HorizontalScrollLockSection = ({ image, textBlocks }) => {
  const sectionRef = useRef(null);
  const scrollContentRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const scrollContent = scrollContentRef.current;

    const handleWheel = (e) => {
      const inView = isElementFullyInView(section);
      if (!inView) return;

      e.preventDefault(); // Lock vertical scroll
      scrollContent.scrollLeft += e.deltaY; // Move content horizontally
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, []);

  const isElementFullyInView = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top <= 0 && rect.bottom > window.innerHeight;
  };

  return (
    <section
      ref={sectionRef}
      className="relative h-screen w-full flex items-center justify-center  text-white overflow-hidden"
    >
      <div className="flex flex-col justify-center items-center md:flex-row md:items-stretch md:justify-stretch justify">
        {/* Left image */}
        <div className="w-[70%] md:w-[40%]  flex items-center justify-center p-6">
          <img
            src={image}
            alt="moon"
            className="w-full max-w-md object-contain rounded-md shadow-lg"
          />
        </div>

        {/* Right side scroll container */}
        <div className="relative w-[60%] h-[30vh] md:h-auto flex flex-col justify-between pt-12 pr-2 md:pr-12">
          {/* Horizontally scrollable quotes */}
          <div
            ref={scrollContentRef}
            className="flex flex-1 gap-10 overflow-x-auto overflow-y-hidden snap-x snap-mandatory scroll-smooth"
          >
            {textBlocks.map((block, i) => (
              <div
                key={i}
                className="flex-shrink-0 w-[80%] snap-start flex items-start"
              >
                <h2 className="text-xl md:text-2xl font-semibold italic">
                  {block.quote}
                </h2>
              </div>
            ))}

            {/* Right arrow */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 text-white opacity-60 animate-pulse pointer-events-none">
              <ArrowRight size={24} />
            </div>
          </div>

          {/* Fixed author block at bottom */}
          <div className="flex items-center gap-3 border-t border-white/30 pt-4">
            {textBlocks[0].avatar && (
              <img
                src={textBlocks[0].avatar}
                alt={textBlocks[0].name}
                className="w-10 h-10 rounded-full border border-white"
              />
            )}
            <div>
              <p className="font-bold">{textBlocks[0].name}</p>
              <p className="text-sm text-white/70">{textBlocks[0].role}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HorizontalScrollLockSection;
